import { Row } from '@tanstack/react-table';
import { FeeTypeEnum, PropertyInternalFee } from 'models/PropertyFees';

const TaxationRateCell = ({
  getValue,
  row,
}: {
  getValue: () => number;
  row: Row<PropertyInternalFee>;
}) => {
  const taxRate = getValue();
  const taxType = row.original.type;

  if (taxType === FeeTypeEnum.TAX && taxRate === 0) {
    return '-';
  }

  return `${taxRate}%`;
};

export default TaxationRateCell;
